import {
	createStyles,
	Divider,
	Drawer,
	IconButton,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	makeStyles,
	Theme,
	Typography,
	useTheme,
} from '@material-ui/core';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';
import _ from 'lodash';
import React, { useState } from 'react';
import { IModuleType, Module } from '../../models';
import { useApp } from '../../providers/app.provider';
import { useHistory, useLocation } from 'react-router';
import logo from '../../assets/images/logo.png';
import { useTranslation } from 'react-i18next';
import { drawerWidth } from 'src/shared/constants';

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		drawer: {
			width: drawerWidth,
			flexShrink: 0,
		},
		drawerPaper: {
			width: drawerWidth,
			background: 'url(' + require('../../assets/images/man-with-boxes-transparent.png') + ') bottom left / 240px 250px no-repeat fixed padding-box content-box',
		},
		drawerHeader: {
			display: 'flex',
			alignItems: 'center',
			padding: theme.spacing(0, 1),
			// necessary for content to be below app bar
			...theme.mixins.toolbar,
			justifyContent: 'flex-end',
		},
		drawerSwitchIcon: {
			color: '#fff',
		},
		drawerHeaderBackground: {
			background: `#37517E`,
			backgroundSize: 'contain',
			minHeight: "56px"
		},
		fontSize12px: {
			fontSize: "12px"
		},
		fontBold: {
			fontWeight: "bold"
		},
		nestedSidebarLinks: {
			marginLeft: "32px"
		},
		disableXScroll: {
			overflowX: "hidden"
		},
		sidebarHeaderText: {
			fontWeight: "bold",
			fontSize: "17px",
			color: "white",
			marginTop: "4px"
		}
	})
);

const SidebarComponent: React.FC = props => {
	const { t } = useTranslation();
	const [modules] = useState<IModuleType[]>(_.values(Module));
	const theme = useTheme();
	const classes = useStyles();
	const { isSidebarOpen, toggleSidebar } = useApp(); 
	const history = useHistory();
	const location = useLocation();

	return (
		<Drawer
			className={classes.drawer}
			variant='persistent'
			anchor='left'
			open={isSidebarOpen}
			classes={{
				paper: classes.drawerPaper,
			}}
		>
			<div className={classes.disableXScroll}>
			<div className={`${classes.drawerHeader} ${classes.drawerHeaderBackground}`}>
				<img src={logo} height={36} width={150} /> 
				<Typography noWrap className={classes.sidebarHeaderText}>
					{t("label-tools")}
				</Typography>
				<IconButton onClick={() => toggleSidebar()} size='small' className={classes.drawerSwitchIcon}>
					{theme.direction === 'ltr' ? <ChevronLeft /> : <ChevronRight />}
				</IconButton>
			</div>
			<Divider />
			<List>
				{modules.map(m => {
					const isSelected = m?.url ? location.pathname.includes(m.url) : false;
						return (<>
							<ListItem button key={m.name} onClick={() => m?.url && history.push(m?.url)} >
								<ListItemIcon style={{minWidth: "32px"}}>
									{m?.icon ? <m.icon /> : null}
								</ListItemIcon>
								<ListItemText disableTypography>
									<Typography className={isSelected ? classes.fontBold : ""}>{m.name}</Typography>
								</ListItemText>
							</ListItem>
							{/* Nested sidebar links */}
							{m?.children?.map(child => {
								const isSelected = child?.url ? location.pathname.includes(child.url) : false;
									return (<ListItem button key={child.name} className={classes.nestedSidebarLinks} onClick={() => child?.url && history.push(child?.url)}>
										<ListItemIcon style={{minWidth: "32px"}}>
											{child?.icon ? <child.icon /> : null}
										</ListItemIcon>
										<ListItemText disableTypography> 
											<Typography className={`${isSelected ? classes.fontBold : ""} `}>{child.name}</Typography>
										</ListItemText>
									</ListItem>)
								}
							)}
						</>)
					}
				)}
			</List>
			<Divider />
			</div>
		</Drawer>
	);
};

export default SidebarComponent;
